import React, { memo } from 'react';

import './css/style.scss';
import ProgressBar from 'react-bootstrap/ProgressBar';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import SwiperCore, { EffectFade, Autoplay } from 'swiper';
SwiperCore.use([EffectFade, Autoplay]);
import ShareCard from '../../../ShareCard';
import LazyImage from '../../../CustomLibraries/LazyImage';

const PollCardCompleted = ({ data, isCme = false, gtmTagVariable = '' }) => {
  let sponsorLogo = data?.sponsor_logo ? data?.sponsor_logo.split(',') : [];

  let resultData =
    JSON.parse(isCme ? data?.result_data : data?.json_result) &&
    JSON.parse(isCme ? data?.result_data : data?.json_result)[0];

  return (
    <>
      <div className="w-100 float-start pollCardV1Box shadow rounded-3 bg-white position-relative overflow-hidden p-3 p-md-4">
        <span
          className="graph-1 position-absolute start-0 bottom-0"
          style={{ backgroundColor: '#28ca5a' }}
        ></span>
        <span
          className="graph-2 position-absolute start-0 bottom-0"
          style={{ backgroundColor: '#28ca5a' }}
        ></span>

        <div className="w-100 float-start pollCrdV1Btm">
          <div className="crdV1topPart d-flex align-items-center justify-content-between position-relative mb-2">
            {/* <span className="crdV1topPartGraph" style={{ backgroundColor: "#28ca5a" }}></span> */}
            <h4 className="text-black rounded fs-4 pollCardV1Point py-2 px-3 border border-dark">
              <span className="fw-bold">{data?.point}</span> Points
            </h4>
            <a href="javascript:void(0)" className="cardV1DotsMenu text-black">
              <ShareCard
                data={{ title: data?.survey_title, url: data?.deeplink }}
                customClass={`${gtmTagVariable}_pollCardCompleted_share`}
                // id={`${gtmTagVariable}_pollCardCompleted_share_${data?.survey_id}`}
              />
            </a>
          </div>
          <div className="w-100 float-start d-flex text-start cardV1Topic mb-2">
            <div className="cardV1TopicContent position-relative w-100">
              <h4 className="text-black fs-16 fw-medium">{resultData?.question ?? ''}</h4>
            </div>
          </div>
          <div className="w-100 float-start cardV1Ftr mt-2">
            <div className="w-100 float-start pollCardV1Ansr">
              {resultData?.options &&
                resultData?.options?.length > 0 &&
                resultData?.options.map((_option, index) => (
                  <div className="fs_4 pollCardV1AnsrRow position-relative mb-3" key={index + 1}>
                    <ProgressBar now={_option.vote} />
                    <div
                      className={`pollCardV1AnsrRowIn py-4 position-relative z-2 text-start font-semibold ${
                        resultData?.selectedIndex == _option.value ? 'text-primary' : 'text-black'
                      } `}
                    >
                      {_option.label}
                      <span className="position-absolute">
                        {_option.vote}
                        {' %'}
                      </span>
                    </div>
                  </div>
                ))}
            </div>
            {/* sponser logo if single */}
            {sponsorLogo?.length == 1 && (
              <div className="crdV1sponser mt-4 text-end float-end">
                <div className="crdV1sponserIn bg-white d-inline-flex justify-content-end align-items-center">
                  <LazyImage src={sponsorLogo[0]} className="float-end" alt="sponsor_logo" logo />
                </div>
              </div>
            )}
            {/* sponser logo if multiple */}
            {sponsorLogo?.length > 1 && (
              <Swiper
                className="crdV1sponser mt-4 text-end float-end"
                navigation={false}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                autoplay={{
                  delay: 2500
                }}
                effect={'fade'}
              >
                {sponsorLogo?.map((logo, _i) => (
                  <SwiperSlide
                    className="crdV1sponserIn bg-white d-inline-flex justify-content-end align-items-center"
                    key={_i + 1}
                  >
                    <LazyImage src={logo} className="float-end" alt="sponsor_logo" logo />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
            {/* sponser logo if multiple */}
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(PollCardCompleted);
